/* eslint-disable */
import React, { useState } from 'react';
import {
  Box,
  Select,
  MenuItem,
  TextField,
  InputAdornment,
} from '@mui/material';
import { setMonth, getMonth, setYear, getYear } from 'date-fns';
import { ReactComponent as CustomDropDownArrow } from '../../Assets/images/svg/dar_drop_down_arrow.svg';
import { ReactComponent as CustomSearchIcon } from '../../Assets/images/svg/dar_search.svg';
import './customDateRange.scss';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';

const MONTHS = Array.from({ length: 12 }, (_, index) => ({
  id: index,
  name: dayjs().month(index).format('MMM'),
}));

const CustomHeader = ({ date, setDate, useCurrentYear }) => {
  const [monthSearchTerm, setMonthSearchTerm] = useState('');
  const [yearSearchTerm, setYearSearchTerm] = useState('');
  const [openMonth, setOpenMonth] = useState(false);
  const [openYear, setOpenYear] = useState(false);

  const currentMonth = getMonth(date);
  const selectedYear = getYear(date);
  const currentYear = new Date().getFullYear();
  const yearToUse = useCurrentYear ? currentYear : selectedYear;

  const yearOptions = Array.from({ length: yearToUse - 1980 + 1 }, (_, index) => ({
    id: 1980 + index,
    name: (1980 + index).toString(),
  }));

  const handleMonthChange = (event) => {
    const newMonth = parseInt(event.target.value);
    const updatedDate = setMonth(date, newMonth);
    setDate(updatedDate);
    setMonthSearchTerm('');
    setOpenMonth(false);
  };

  const handleYearChange = (event) => {
    const newYear = parseInt(event.target.value);
    const updatedDate = setYear(date, newYear);
    setDate(updatedDate);
    setYearSearchTerm('');
    setOpenYear(false);
  };
  const filterExactMatch = (term, value) => 
    term.trim() !== '' &&
    term.trim().length === value.length &&
    term.trim().toLowerCase() === value.toLowerCase();

  return (
    <Box className="header-container">
      <Box className="month-select-container">
        <Select
          variant="standard"
          value={currentMonth}
          onChange={handleMonthChange}
          onOpen={() => setOpenMonth(true)}
          onClose={() => setOpenMonth(false)}
          open={openMonth}
          MenuProps={{
            disablePortal: true,
            PaperProps: {
              className: 'menu-paper',
              sx: {
                maxHeight: '200px',
                width: '150px',
                overflowY: 'auto',
              },
            },
            getContentAnchorEl: null,
          anchorOrigin: 
              {vertical: 'bottom', horizontal: 'left' },
            transformOrigin: { vertical: 'top', horizontal: 'left' },
            }}
            className="custom-select"
            IconComponent={CustomDropDownArrow}
          >
            <MenuItem disableRipple>
              <TextField
                variant="standard"
                size="small"
                value={monthSearchTerm}
                onChange={(e) => setMonthSearchTerm(e.target.value)}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <CustomSearchIcon />
                    </InputAdornment>
                ),
                onClick: (e) => e.stopPropagation(),
              }}
            />
          </MenuItem>  
            {MONTHS.map(({ id, name }) => (
              <MenuItem
                key={id}
                value={id}
                className={`month-item menu-item ${
                  monthSearchTerm && filterExactMatch(monthSearchTerm, name) 
                    ? 'highlight' 
                    : ''
                }`}
                onClick={() => {
                  handleMonthChange({ target: { value: id } });
                  setMonthSearchTerm('');
                }}
              >
                {name}
              </MenuItem>
            ))}
        </Select>
      </Box>

      <Box className="year-select-container">
        <Select
          variant="standard"
          value={selectedYear}
          onChange={handleYearChange}
          onOpen={() => setOpenYear(true)}
          onClose={() => setOpenYear(false)}
          open={openYear}
          MenuProps={{
            disablePortal: true,
            PaperProps: {
              sx: {
                maxHeight: '200px',
                width: '150px',
                overflowY: 'auto',
              },
            },
            getContentAnchorEl: null,
            anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
            transformOrigin: { vertical: 'top', horizontal: 'left' },
          }}
          className="custom-select"
          IconComponent={CustomDropDownArrow}
        >
          <MenuItem disableRipple>
            <TextField
              variant="standard"
              size="small"
              value={yearSearchTerm}
              onChange={(e) => setYearSearchTerm(e.target.value)}
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <CustomSearchIcon />
                  </InputAdornment>
                ),
                onClick: (e) => e.stopPropagation(),
              }}
            />
          </MenuItem>

        {yearOptions.map(({ id, name }) => (
            <MenuItem
              key={id}
              value={id}
              className={`year-item menu-item ${
                  yearSearchTerm && filterExactMatch(yearSearchTerm, name) 
                    ? 'highlight' 
                : ''
              }`}
              onClick={() => handleYearChange({ target: { value: id } })}
            >
              {name}
            </MenuItem>
          ))}
        </Select>
      </Box>
    </Box>
    );
};

CustomHeader.propTypes = {
  date: PropTypes.instanceOf(Date).isRequired,
  setDate: PropTypes.func.isRequired,
  useCurrentYear: PropTypes.bool,
};

export default CustomHeader;
